// To check if performance is supported


export default function() {
    try {
        return 'performance' in window && 'mark' in performance;
    }

    catch (e) {
        console.log('Performance metrics not available');
    }

    return false;
}
